<template>
  <div>
    <van-nav-bar title="修改昵称" left-arrow @click-left="$router.go(-1)" />
    <van-cell-group>
      <van-field value="请输入用户昵称" label="用户昵称" v-model="nickname" />
    </van-cell-group>
    <van-button type="danger" size="large" @click="changeName">提交</van-button>
  </div>
</template>


<script>
export default {
  data() {
    return {
      nickname: "", //用户昵称
    };
  },
  created() {
    this.Post({}, "/main/userinfo", (res) => {
      if (res.states == 1) {
        this.nickname = res.data.nickname;
      } else if (res.states == 400) {
        this.$router.replace("/login");
      } else {
        this.Toast.fail(res.msg);
      }
    });
  },
  methods: {
    changeName() {
      this.Post(
        {
          nickname: this.nickname,
        },
        "/main/changeName",
        (res) => {
          if (res.states == 1) {
            this.Toast.success("昵称修改成功");
          } else {
            this.Toast.fail(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/mine/changeName.vue